import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { ScreenShareService } from 'src/shared/services/screen-share.service';

@Component({
  selector: 'app-screen-share-viewer',
  templateUrl: './screen-share-viewer.component.html',
  styleUrls: ['./screen-share-viewer.component.scss'],
  standalone: false,
})
export class ScreenShareViewerComponent implements OnInit, OnDestroy {
  sessionActive = signal(false);
  sharerEmail = signal<string | null>(null);
  frameSrc = signal<string | null>(null);

  private prevObjectUrl: string | null = null;
  private subscriptions = new Subscription();

  constructor(private readonly screenShareService: ScreenShareService) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.screenShareService.session$.subscribe((email) => {
        this.sessionActive.set(email !== null);
        this.sharerEmail.set(email);
        if (!email && this.prevObjectUrl) {
          URL.revokeObjectURL(this.prevObjectUrl);
          this.prevObjectUrl = null;
          this.frameSrc.set(null);
        }
      }),
    );

    this.subscriptions.add(
      this.screenShareService.frame$.subscribe((blob) => {
        const objectUrl = URL.createObjectURL(blob!);
        if (this.prevObjectUrl) URL.revokeObjectURL(this.prevObjectUrl);
        this.prevObjectUrl = objectUrl;
        this.frameSrc.set(objectUrl);
      }),
    );
  }

  stopSharing(): void {
    if (this.sharerEmail()) {
      this.screenShareService.stopScreenShare(this.sharerEmail()!);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    if (this.prevObjectUrl) URL.revokeObjectURL(this.prevObjectUrl);
  }
}
